import { jsPDF } from 'jspdf'

// Page constants matching the Android generator
const PAGE_WIDTH = 595
const PAGE_HEIGHT = 842
const MARGIN = 48
const CONTENT_WIDTH = PAGE_WIDTH - MARGIN * 2

const COLOR_PRIMARY = '#20262B'
const COLOR_SUBTLE  = '#7792A8'
const COLOR_DIVIDER = '#E0E4E8'

/**
 * Generates a backup codes PDF and triggers a browser download.
 *
 * @param backupCodes  - Array of backup code strings
 * @param filename     - Override the default filename
 */
export function downloadBackupCodesPdf(backupCodes, filename = 'gadzoom_backup_codes.pdf') {
    const doc = new jsPDF({
        unit: 'pt',
        format: [PAGE_WIDTH, PAGE_HEIGHT],
    })

    let y = MARGIN + 16

    // App name
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(11)
    doc.setTextColor(COLOR_SUBTLE)
    doc.setCharSpace(1.1)
    doc.text('GADZOOM', MARGIN, y)
    doc.setCharSpace(0)
    y += 24

    // Title
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(26)
    doc.setTextColor(COLOR_PRIMARY)
    doc.text('Backup Codes', MARGIN, y)
    y += 10

    // Divider
    drawDivider(doc, y)
    y += 20

    // Description
    doc.setFont('helvetica', 'normal')
    doc.setFontSize(12)
    doc.setTextColor(COLOR_PRIMARY)

    const description =
        'Save these backup codes in a secure location. Each code can be used once if you lose access to your two-factor authentication method'

    const descLines = doc.splitTextToSize(description, CONTENT_WIDTH)
    doc.text(descLines, MARGIN, y)
    y += descLines.length * 16 + 28

    // Codes section header
    doc.setFont('helvetica', 'bold')
    doc.setFontSize(9)
    doc.setTextColor(COLOR_SUBTLE)
    doc.setCharSpace(1.1)
    doc.text('YOUR BACKUP CODES', MARGIN, y)
    doc.setCharSpace(0)
    y += 16

    drawDivider(doc, y)
    y += 20

    // Codes 2-column grid
    doc.setFont('courier', 'bold')
    doc.setFontSize(14)
    doc.setTextColor(COLOR_PRIMARY)

    const colWidth = CONTENT_WIDTH / 2

    for (let i = 0; i < backupCodes.length; i += 2) {
        doc.text(backupCodes[i], MARGIN, y)
        if (backupCodes[i + 1]) {
            doc.text(backupCodes[i + 1], MARGIN + colWidth, y)
        }
        y += 28
    }

    y += 8
    drawDivider(doc, y)
    y += 20

    // Footer
    doc.setFont('helvetica', 'normal')
    doc.setFontSize(10)
    doc.setTextColor(COLOR_SUBTLE)
    doc.text('Each code can only be used once. Store this document in a safe place.', MARGIN, y)

    // Save
    doc.save(filename)
}

function drawDivider(doc, y) {
    doc.setDrawColor(COLOR_DIVIDER)
    doc.setLineWidth(1)
    doc.line(MARGIN, y, PAGE_WIDTH - MARGIN, y)
}